import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from '@app/dashboard/print/services/print.service';
import { CurrencySign, CurrencyUnit } from '@pdqdev/pdq-shared/dist/entities';
import { getDefaultCurrencySign, getSignOfCurrency } from 'src/utils';
import { OrderBatchService } from '@app/services/order-batch/order-batch.service';
import { ShopService } from '@app/services/shops/shop.service';
import { IServiceLevelChosenRates, IServiceLevelProviderChosenRates } from '@pdqdev/pdq-shared/dist/interfaces';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-saveasbatch',
  templateUrl: './saveasbatch.component.html',
  styleUrls: ['./saveasbatch.component.scss'],
  standalone: false,
})
export class SaveasbatchComponent implements OnInit {
  readonly displayedColumns: string[] = ['CarrierName', 'OrderNumber', 'Amount'];

  @ViewChild('batchNameEditInput') batchNameEditInput: ElementRef;
  carrierId = 1;
  batchNameInput = '';
  showBatchNameEdit = false;
  editBatchNameButtonIcon = 'edit';
  editBatchNameButtonText = 'Label batch for reference';
  shouldDisplayOrders = false;
  currencySign: CurrencySign;
  ratesData: IServiceLevelChosenRates | null;
  forceFulfillScreenNavigate: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public acknowledgedialog: MatDialog,
    public dialogRef: MatDialogRef<SaveasbatchComponent>,
    public innerDialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderBatchService: OrderBatchService,
    private printService: PrintService,
    private _shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.currencySign = getDefaultCurrencySign();
    this.initShopService();
    this.ratesData = this.data.batch?.rateInfo?.selectedServiceLevelRatesData ?? null;
  }

  initShopService() {
    this._shopService.shop$.pipe(first()).subscribe((shop) => {
      const {
        metadata: { currency, forceFulfillScreenNavigate },
      } = shop;
      if (currency) {
        this.currencySign = getSignOfCurrency(currency.toUpperCase?.() as CurrencyUnit);
        this.forceFulfillScreenNavigate = forceFulfillScreenNavigate;
      }
    });
  }

  confirming = false;

  toggleBatchNameEdit(): void {
    this.showBatchNameEdit = !this.showBatchNameEdit;
    if (!this.showBatchNameEdit) {
      this.batchNameInput = '';
      this.editBatchNameButtonIcon = 'edit';
      this.editBatchNameButtonText = 'Label batch for reference';
    } else {
      this.editBatchNameButtonIcon = 'cancel';
      this.editBatchNameButtonText = 'Cancel';
      setTimeout(() => {
        // this will make the execution after the above boolean has changed
        this.batchNameEditInput.nativeElement.focus();
      }, 0);
    }
  }

  onViewOrdersClicked(): void {
    this.shouldDisplayOrders = true;
  }

  onBackClickced(): void {
    this.shouldDisplayOrders = false;
  }

  confirm(): void {
    if (!this.confirming) {
      this.confirming = true;
      console.log(`Confirm batch debug`);
      this.orderBatchService
        .confirmBatch(
          this.data.batch.id,
          this.batchNameInput,
          this.ratesData?.ratesPerProviders?.find((val) => val?.isOptimal),
        )
        .then(() => {
          this.data.close = 'close';
          this.dialogRef.close({ closeDialog: true });
          if (this.forceFulfillScreenNavigate) {
            this.router.navigate(['/dashboard/fulfill/']);
          }
          this.confirming = false;
        });
    }
  }

  getBatchCarrierValue() {
    const optimalProviderRates: IServiceLevelProviderChosenRates = this.ratesData?.ratesPerProviders?.find(
      (val) => val?.isOptimal,
    );
    return optimalProviderRates?.provider && this.ratesData?.serviceLevel
      ? `${optimalProviderRates.provider} - ${this.ratesData.serviceLevel}`
      : this.data.batch.selectedCarrier.name;
  }

  closebtn() {
    this.printService.deleteUnConfirmedBatch(this.data.batch).subscribe((res) => {
      this.dialogRef.close();
    });
  }

  pickConfirmButtonText(data: any) {
    return data?.batch?.rateInfo ? 'CONFIRM & PURCHASE' : 'Batch orders';
  }
}
